import _classCallCheck from "/home/gitlab-runner/builds/c6Ly8Yoi/0/kgsports/kgsport-cms-intl/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/gitlab-runner/builds/c6Ly8Yoi/0/kgsports/kgsport-cms-intl/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/home/gitlab-runner/builds/c6Ly8Yoi/0/kgsports/kgsport-cms-intl/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/home/gitlab-runner/builds/c6Ly8Yoi/0/kgsports/kgsport-cms-intl/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import { Activity } from "../api";
import "../common";
import { BaseResource } from "@kgsport-cms/common";
/**
 *
 * 优惠活动
 * created by 六月
 * 2022-02-18
 *
 */
export var ActivityService = /*#__PURE__*/function (_BaseResource) {
  _inherits(ActivityService, _BaseResource);
  var _super = _createSuper(ActivityService);
  function ActivityService() {
    _classCallCheck(this, ActivityService);
    return _super.apply(this, arguments);
  }
  _createClass(ActivityService, [{
    key: "typeList",
    value:
    // 活动类型
    function typeList(params) {
      return this.requester.get(Activity.typeList, {
        params
      });
    }
    // 活动列表
  }, {
    key: "list",
    value: function list(params) {
      return this.requester.get(Activity.list, {
        params
      });
    }
    // 优惠详情
  }, {
    key: "details",
    value: function details(params) {
      return this.requester.get(Activity.detail, {
        params
      });
    }
  }, {
    key: "apply",
    value: function apply(params) {
      return this.requester.get(Activity.click, {
        params
      });
    }
    // 红包配置信息
  }, {
    key: "getRedEnvelopeInfo",
    value: function getRedEnvelopeInfo() {
      return this.requester.get(Activity.redEnvelopeInfo);
    }
    // 开红包
  }, {
    key: "openRedPacket",
    value: function openRedPacket() {
      return this.requester.post(Activity.drawRedEnvelope);
    }
    // 查询红包明细真实数据
  }, {
    key: "queryWelfareDetailList",
    value: function queryWelfareDetailList() {
      return this.requester.get(Activity.queryWelfareDetail);
    }
    // 查询红包明细虚拟数据
  }, {
    key: "queryUnrealWelfareDetailList",
    value: function queryUnrealWelfareDetailList() {
      return this.requester.get(Activity.queryUnrealWelfareDetail);
    }
    // 获取红包数量
  }, {
    key: "getRedEnvelopeCount",
    value: function getRedEnvelopeCount() {
      return this.requester.get(Activity.RedEnvelopeCount);
    }
    // 转盘信息
  }, {
    key: "getActivityTurntableDetail",
    value: function getActivityTurntableDetail(params) {
      return this.requester.get(Activity.TurntableDetail, {
        params
      });
    }
    // 转盘抽奖
  }, {
    key: "drawTurntable",
    value: function drawTurntable(data) {
      return this.requester.post(Activity.drawTurntable, data);
    }
  }, {
    key: "titleList",
    value: function titleList() {
      return this.requester.get(Activity.titleList);
    }
  }]);
  return ActivityService;
}(BaseResource);